import { render } from "./AyudaAtencion.vue?vue&type=template&id=ef60c938&scoped=true"
import script from "./AyudaAtencion.vue?vue&type=script&lang=js"
export * from "./AyudaAtencion.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=ef60c938&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef60c938"]])

export default __exports__